import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
var defaultProps = {
  /**
   * @ignore
   */
  disabled: false,

  /**
   * @ignore
   */
  selectedStateDoubleBorder: false,

  /**
   * @ignore
   */
  outOfStock: false,

  /**
   * @ignore
   */
  inverted: false,

  /**
   * @ignore
   */
  colorConfig: colors
};
var propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  inverted: PropTypes.bool,
  //1.0
  selectedStateDoubleBorder: PropTypes.bool,
  outOfStock: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,
  //Deprecated
  checked: PropTypes.bool
};
var StyledWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-h49z4w-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  height: 100%;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n"])));
var SelectStyles = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: ", " solid\n    ", ";\n  border-radius: 50%;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  display: block;\n  left: 50%;\n  height: 100%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n"])), calculateRem(1), function (_ref) {
  var colorConfig = _ref.colorConfig,
      inverted = _ref.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig,
      inverted = _ref2.inverted;
  return "inset 0 0 0 ".concat(calculateRem(2), " ").concat(inverted ? colorConfig.black : colorConfig.white);
}); //If its out of stock,

var offsetInner = 2;
var CheckedShape = /*#__PURE__*/styled.span.withConfig({
  displayName: "CheckedShape",
  componentId: "sc-h49z4w-1"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), SelectStyles, function (_ref3) {
  var selectedStateDoubleBorder = _ref3.selectedStateDoubleBorder,
      outOfStock = _ref3.outOfStock,
      selected = _ref3.selected,
      colorConfig = _ref3.colorConfig,
      inverted = _ref3.inverted;
  return (selectedStateDoubleBorder || outOfStock) && "\n  &:after {\n    position: absolute;\n    content:'';\n    top: ".concat(offsetInner, "px;\n    left: ").concat(offsetInner, "px;\n    height: calc(100% - 6px);\n    width: calc(100% - 6px);\n    background: transparent;\n    border-radius: 50%;\n    border: 1px solid ").concat(selected && !inverted ? colorConfig.black : selected && inverted ? colorConfig.white : colorConfig.coolGray6, ";\n  }\n  ");
});
var DisabledShape = /*#__PURE__*/styled.span.withConfig({
  displayName: "DisabledShape",
  componentId: "sc-h49z4w-2"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  &::before {\n    background-color: ", ";\n    content: '';\n    height: ", ";\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n    width: 100%;\n    z-index: 1;\n  }\n"])), SelectStyles, function (_ref4) {
  var outOfStock = _ref4.outOfStock,
      selected = _ref4.selected,
      colorConfig = _ref4.colorConfig,
      inverted = _ref4.inverted;
  return outOfStock && "\n    border: ".concat(calculateRem(1), " solid ").concat(selected && !inverted ? colorConfig.black : selected && inverted ? colorConfig.white : colorConfig.coolGray6, ";\n    ");
}, function (_ref5) {
  var selected = _ref5.selected,
      outOfStock = _ref5.outOfStock,
      colorConfig = _ref5.colorConfig,
      inverted = _ref5.inverted;
  return outOfStock && !selected ? colorConfig.coolGray6 : outOfStock && selected && inverted ? colorConfig.white : colorConfig.black;
}, calculateRem(1));
/**
 * @ignore
 */

var ColorIcon = function ColorIcon(props) {
  var disabled = props.disabled,
      checked = props.checked,
      selected = props.selected,
      selectedStateDoubleBorder = props.selectedStateDoubleBorder,
      outOfStock = props.outOfStock,
      colorConfig = props.colorConfig,
      inverted = props.inverted;
  var isSelected = checked || selected;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, (isSelected || outOfStock) && /*#__PURE__*/React.createElement(CheckedShape, {
    selected: isSelected,
    outOfStock: outOfStock,
    selectedStateDoubleBorder: selectedStateDoubleBorder,
    colorConfig: colorConfig,
    inverted: inverted
  }), (disabled || outOfStock) && /*#__PURE__*/React.createElement(DisabledShape, {
    selected: isSelected,
    outOfStock: outOfStock,
    colorConfig: colorConfig,
    inverted: inverted
  }));
};

ColorIcon.defaultProps = defaultProps;
ColorIcon.propTypes = propTypes;
export default ColorIcon;